module.exports = __webpack_public_path__ + "img/computador.0cf98382.png";